interface RecommendationsListProps {
  recommendations: string[]
}

export function RecommendationsList({ recommendations }: RecommendationsListProps) {
  return (
    <ul className="space-y-2 text-sm">
      {recommendations.map((rec, index) => (
        <li
          key={index}
          className="py-1.5 pl-4 relative before:content-['•'] before:absolute before:left-0 before:text-violet-300"
        >
          {rec}
        </li>
      ))}
    </ul>
  )
}
